import {
	IconInboxOutline18,
	IconStackPerspectiveOutline18,
	IconOffice3Outline18,
} from "nucleo-ui-outline-18"

import { Avatar, IssueStatusIcon, LucideIcon } from "@productlane/ui"

import type { ContextMentionItem } from "./context-mention"
import { FeedbackOriginIconRecord } from "@/lib/feedback"
import { getProjectIcon } from "@/lib/projects"

type IconItem = Pick<
	ContextMentionItem,
	"type" | "color" | "status" | "icon" | "imageUrl" | "label" | "origin"
>

// People and companies read as themselves, so they get their avatar or logo;
// docs and projects carry an icon the user picked.
export const ContextMentionIcon = ({
	item,
	className,
	avatarSize = "xxs",
}: {
	item: IconItem
	className: string
	avatarSize?: "xxs" | "xxs+" | "xs"
}) => {
	switch (item.type) {
		case "issue":
			return (
				<IssueStatusIcon
					className={className}
					status={item.status ?? ""}
					color={item.color ?? ""}
				/>
			)
		case "project": {
			const ProjectIcon = getProjectIcon(item.icon)
			return <ProjectIcon className={className} style={{ strokeWidth: 1.5 }} />
		}
		case "article":
			return (
				<LucideIcon
					icon={item.icon}
					className={className}
					style={{ strokeWidth: 1.5 }}
				/>
			)
		case "changelog":
			return (
				<IconStackPerspectiveOutline18
					className={className}
					strokeWidth={1.5}
				/>
			)
		case "thread": {
			const OriginIcon = item.origin
				? FeedbackOriginIconRecord[
						item.origin as keyof typeof FeedbackOriginIconRecord
					]
				: null
			if (!OriginIcon) {
				return <IconInboxOutline18 className={className} strokeWidth={1.5} />
			}
			return <OriginIcon className={className} />
		}
		case "user":
		case "contact":
			return (
				<Avatar
					size={avatarSize}
					name={item.label}
					image={item.imageUrl}
					roundness="full"
					className="flex-none"
				/>
			)
		case "company":
			return item.imageUrl ? (
				<Avatar
					size={avatarSize}
					name={item.label}
					image={item.imageUrl}
					roundness="md"
					className="flex-none"
				/>
			) : (
				<IconOffice3Outline18 className={className} strokeWidth={1.5} />
			)
	}
}
